function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "m133.195312 153.914062 70.253907 70.253907 21.207031-21.210938-70.253906-70.253906v-56.351563l-105.886719-76.3437495-48.015625 48.0156255 76.34375 105.890624zm0 0"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "m358.847656 26.332031c-45.78125 45.808594-18.222656 99.8125-17.972656 102.8125l-211.21875 211.269531c-3-.230468-56.878906-27.988281-102.8125 17.945313-26.921875 26.9375-33.980469 68.097656-17.59375 102.445313l60.027344-60.011719 42.421875 42.421875-60.011719 60.011718c33.589844 16.0625 74.867188 9.996094 102.429688-17.59375 45.804687-45.777343 18.222656-99.796874 17.972656-102.796874l211.21875-211.257813c3 .296875 57.066406 27.8125 102.8125-17.972656 26.9375-26.921875 33.996094-68.082031 17.59375-102.433594l-60.011719 60.011719-42.421875-42.417969 60.011719-60.027344c-33.378907-15.882812-74.640625-10.167969-102.445313 17.59375zm0 0"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "m266.984375 330.089844 63.59375-63.59375 21.300781 21.300781-63.597656 63.59375zm0 0"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "m448.878906 511.988281-139.292968-139.292969 63.597656-63.59375 139.289062 139.289063zm0 0"
});

var SvgMaintenance = function SvgMaintenance(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "0 0 511 511.99994",
    width: "511pt",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMaintenance, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/maintenance.50677351.svg";
export { ForwardRef as ReactComponent };